import React from 'react'

export default function Footer() {
  return (
    <div className='mt-24 pb-6'>
        <div className="container">
            <p className='text-center text-bg opacity-80'>
                &copy; 2023 Pancake. All rights reserved.
            </p>
        </div>
    </div>
  )
}
